module.exports = __webpack_public_path__ + "static/img/ic_gy_d_cl.d8523aea.png";